<template>
    <neo-pagination 
      v-model="model"
      :currentPage="model" 
      :totalPageCount="pagesTotal" 
      :pageLimit="pageLimit" 
      :showFirstAndLast="!showFirstAndLast"
    />
</template>

<script>
import NeoPagination from "@shared/saas-components/pagination";

export default {
  name: 'Pagination',
  components: {
    NeoPagination
  },
  props: {
    value: {
      type: Number,
      default: 1,
    },
    pageLimit: {
      type: Number,
      default: 10,
    },
    totalItemsCount: Number,
  },
  data() {
    return {
      currentPage: 1,
    }
  },
  computed: {
    pagesTotal() {
      return Math.ceil(this.totalItemsCount / this.pageLimit);
    },
    showFirstAndLast() {
      return true
    },
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
};
</script>